import { forwardRef, type Ref, type SVGProps } from "react";
const IconNotificationOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M24.36 12.54A8.53 8.53 0 0 0 17 4.07S17 4 17 4V3a1 1 0 0 0-2 0v1.06a8.29 8.29 0 0 0-7.37 8.19c0 8.23-4.64 6.47-4.64 11v.92A1.84 1.84 0 0 0 4.86 26h7.69a4 4 0 0 0-.05.5 3.5 3.5 0 0 0 7 0 4 4 0 0 0-.05-.5h7.69A1.84 1.84 0 0 0 29 24.17v-.92c0-4.48-4.53-2.81-4.64-10.71m-6.86 14a1.5 1.5 0 0 1-3 0 1.6 1.6 0 0 1 .09-.5h2.82a1.6 1.6 0 0 1 .09.46ZM27 24H5v-.75c0-1.06.3-1.34 1.18-2.17 1.82-1.71 3.46-3.67 3.46-8.83A6.31 6.31 0 0 1 16 6h.56a6.57 6.57 0 0 1 5.8 6.54c.07 5.35 2 7.18 3.46 8.52.88.83 1.18 1.11 1.18 2.17Z" />
  </svg>
);
const ForwardRef = forwardRef(IconNotificationOutlineSVG);
ForwardRef.displayName = "IconNotificationOutline";
export { ForwardRef as IconNotificationOutline };
